
















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IClient } from '@/api/types-client'

@Component({
  name: 'ClientInformation'
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IClient;

  toggleHistory(): void {
    console.log(' toggle history ')
  }
}
